let setLoadingFn: ((value: boolean) => void) | null = null;

export const registerSetLoading = (fn: (value: boolean) => void) => {
  setLoadingFn = fn;
};

export const showGlobalLoader = () => {
  setLoadingFn?.(true);
};

export const hideGlobalLoader = () => {
  setLoadingFn?.(false);
};
